import { durationText } from 'reusable/durationText';

export const timeStringToSeconds = (time: string | null): number => {
  if (!time) return 0;
  const parts = time.split(':').map(Number);

  if (time.includes(' ')) {
    const [days, rest] = time.split(' ');
    const [hours, minutes, seconds] = rest.split(':').map(Number);
    return Number(days) * 86400 + hours * 3600 + minutes * 60 + seconds;
  }

  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }

  return 0;
};

export const secondsToHoursAndMinutes = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return { hours, minutes };
};

/**
 * 配送先の「今年の合計時間」の表示（EV-114 / EV-115 / ADM-21）。配送先詳細と編集画面で同じものを使う。
 *
 * - null / undefined: 読み込み中・取得できない・対象外は「-」
 * - 1時間未満（0時間を含む）: 分だけ（0分）。以前は0時間を null にして「-」と出し、読み込み中・失敗と
 *   区別できず、編集画面（0 min）と食い違っていた。
 * - それ以外: 時間と分
 * - 数でない・負の値（EV-312）: 「-」（英語の入れ子の文言が崩れないよう、文言に渡さない）
 */
export const formatTotalDuration = (
  t: (key: string, options?: Record<string, unknown>) => string,
  value: { hours: number; minutes: number } | null | undefined
): string => {
  if (!value) return '-';
  if (value.hours === 0) return durationText(t, 'detail.minutes_value', { minutes: value.minutes });
  return durationText(t, 'detail.hours_minutes', { hours: value.hours, minutes: value.minutes });
};

/**
 * 秒を、小数2桁の時間の文字列（例 26.50）にする。配送先分析の CSV とグラフで同じものを使う（ADM-21）。
 *
 * PR #224 の独立照合（HR-AC3）。以前は CSV が「秒÷3600」、グラフが「時＋分/60＋秒/3600」を
 * toFixed(2) で丸めていたため、ちょうど半分の値で浮動小数点の誤差により丸めの向きが分かれた
 * （例 126秒は CSV 0.04・グラフ 0.03）。100分の1時間は36秒なので、秒÷36 を整数に四捨五入して
 * から小数2桁にする（整数の秒なら秒÷36 のちょうど半分は正確に表せ、常に切り上げになる）。
 * 0以下・数でない値は 0.00。
 */
export const secondsToHoursText = (totalSeconds: number): string => {
  const hundredths = totalSeconds > 0 ? Math.round(totalSeconds / 36) : 0;
  return `${Math.floor(hundredths / 100)}.${String(hundredths % 100).padStart(2, '0')}`;
};
